import React from "react";
import { MdOutlineBrightness4, MdOutlineBrightnessMedium } from "react-icons/md";

import { useTheme } from "../context/ThemeContext";
import Button from "./Button";

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  return (
    <div className="flex items-center justify-end space-x-2">
      <Button icon={<MdOutlineBrightness4 size={20} />} onClick={toggleTheme} variant="text" color="white" />
    </div>
  );
};

export default ThemeToggle;
